<style lang='scss'>
	#main-handhomes{
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .75rem;
		}
		
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .75rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	
	#tubody-mains>div{
		padding: 1px 0;
	}
	
	#tubody-mains{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			/* overflow-y: auto; */
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.look_g{
			font-size: .75rem;
			margin-bottom: .5rem;
			color: #0c8b97;
			div{
				display: inline-block;
				width: 1px;
				height: 0.75rem;
				position: relative;
				top: .1rem;
				margin-right: .2rem;
				border-left: 3px solid #0c8b97;
			}
		}
		
		.main-wid{
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		
		.ant-col {
			font-size: .75rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.75rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .75rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		.warp_daochu{
			display: flex;
			justify-content: space-between;
			padding: .5rem .5rem 1rem;
			div{
				font-size: .7rem;
			}
		}
	}

</style>
<template>
	<div>
		<a-modal
		width='45rem'
		id='main-handhomes'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:dialog-style="{ top: '12vh' }"
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;font-size: 0.9rem;">
					{{isname}}
				</div>
			</div>
			<div>
				<div v-for='(item,ind) in titlearr' :key='ind + "0716"' v-if='!item.ishand'
				:class='island == item.component?"wland":"gland"' @click="fanfn(item)">
					{{item.name}}
				</div>
			</div>
			<div id='tubody-mains'>
				 
				<component :is='island' :ref='island' :applyid='applyid'
				:pared='itemobj.type==isind+1?itemobj:{}' @child="$emit('child', 1)"></component>
				
				<div>
					<div style="width: 100%;height: 1px;border-bottom: 1px solid rgb(232, 232, 232);margin-bottom: .4rem;"></div>
					<div class='warp_daochu' v-if="isname == '員工信息'">
						<div style="padding-left: .5rem;"></div>
						<div>
							<button class='btn1 btn2' @click='resetForm("3")'>下一頁</button>
						</div>
					</div>
					<div class='warp_daochu' v-else>
						<div style="padding-left: .5rem;"></div>
						<div>
							<button class='btn1 btnx' @click='resetForm("1")'>儲存</button>
							<button class='btn1 btn2' @click='resetForm("2")'>提交</button>
						</div>
					</div>
	
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import handitemjiaban from './handitemjiaban.vue'
	import handitemqi from './handitemqi.vue'
	import handitemxinxi from './handitemxinxi.vue'
	import handitemwaichu from './handitemwaichu.vue'
	import handme from './handme.vue'
		
	export default {
		name:'handhome',
		props:['itemobj','applyid'],
		components:{
			handitemjiaban,
			handitemqi,
			handme,
			handitemxinxi,
			handitemwaichu
			},
		data(){
			return {
				isind: 0,
				isname: '員工信息',
				visible:true,
				island: 'handitemxinxi',
				titlearr:[
					{
						name:'員工信息',
						component:'handitemxinxi',
						island:true
					},
					{
						name:'申請假期',
						component:'handitemqi',
						island:true
					},
					{
						name:'申請加班',
						component:'handitemjiaban',
						island:false
					},
					{
						name:'申請外出',
						component:'handitemwaichu',
						island:false
					},
					{
						name:'外出總結',
						component:'handme',
						// island:false,
						ishand:true
					},
				]
			}
		},
		mounted() {
			// console.log(this.itemobj,11111111)
		},
		watch:{
			itemobj:{
				deep:true,
				immediate:true,
				handler(ev){
					if(ev.type){
						this.island = this.titlearr[ev.type-1].component;
						this.isname = this.titlearr[ev.type-1].name;
						this.isind = ev.type-1
						console.log(this.titlearr)
					}
				}
			},
			applyid:{
				deep:true,
				immediate:true,
				handler(ev){
					if(this.applyid){
						this.titlearr[3].ishand= false
						this.island = this.titlearr[3].component;
						this.isname = this.titlearr[3].name;
						this.isind = 3
						console.log(this.titlearr)
					}
				}
			}
		},
		methods:{
			resetForm(val){
				if (val == 3) {
					this.island = 'handitemqi'
					this.isname = '申請假期';
					return
				}
				this.$refs[this.island].resetForm(val)
			},
			fanfn(item){
				console.log(item);
				
				this.island = item.component;
				this.isname = item.name;
			},
			handleOk(){
				
			},
			handleCancel(){
				this.$emit('child', 0)
			},
		}
	}
</script>
